<template>
  <div id="app">
    <Landing />
  </div>
</template>

<script>
import Landing from './components/Landing/Landing.vue';

export default {
  name: 'App',
  components: {
    Landing,
  },
};
</script>

<style lang="scss">
</style>
